import buildRoute from './buildRoute'

export const getSubscriptionProfiles = async (active: boolean) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'subscription-profiles',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const postSubscriptionProfile = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'subscription-profile-edit',
            data: formData,
        })
        if (res) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface GetSubscriptionBoatsProps {
    active?: boolean
    page?: number
    limit?: number
    filter?: any
    sort?: any
    // The assign tab wants the whole fleet, not only boats already on a plan.
    includeUnsubscribed?: boolean
    // Narrows a super admin (otherwise unscoped) to their active manufacturer.
    activeManufacturerOnly?: boolean
}

// Server-paginated boat list for the subscription tables. Returns
// { boats, total, page, limit, totalPages, hasNext, hasPrev }.
export const getSubscriptionBoats = async ({
    active = true,
    page = 1,
    limit = 50,
    filter,
    sort,
    includeUnsubscribed,
    activeManufacturerOnly,
}: GetSubscriptionBoatsProps) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'subscription-boats-with-limiter',
            data: {
                active,
                page,
                limit,
                filter,
                sort,
                includeUnsubscribed,
                activeManufacturerOnly,
            },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}

interface AssignBoatSubscriptionsProps {
    boats: any[]
    subscriptionName: string
    startDate?: string | null
    endDate?: string | null
    updatedBy?: string
}

// Assign one profile to a batch of boats. The API archives each boat's own
// outgoing term into `previousSubscriptions`, so replacing is non-destructive.
export const assignBoatSubscriptions = async ({
    boats,
    subscriptionName,
    startDate,
    endDate,
    updatedBy,
}: AssignBoatSubscriptionsProps) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'boat-subscription-bulk-assign',
            data: { boats, subscriptionName, startDate, endDate, updatedBy },
        })
        if (res) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

// One boat's current term plus its archived terms, each with the subscription
// profile populated: { subscription, subscriptionActive, previousSubscriptions }.
export const getBoatSubscriptionHistory = async (boat: string) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'boat-subscription-history',
            data: { boat },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}

interface RemoveBoatSubscriptionsProps {
    boats: any[]
    updatedBy?: string
}

// End the current term on a batch of boats with no replacement. The API archives
// each boat's term into `previousSubscriptions` and reports the boats it skipped
// for having no subscription: { requested, removed, skipped }.
export const removeBoatSubscriptions = async ({
    boats,
    updatedBy,
}: RemoveBoatSubscriptionsProps) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'boat-subscription-bulk-cancel',
            data: { boats, updatedBy },
        })
        if (res) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface SelectionType {
    profiles: []
    activate: boolean
}

// `handleActivation` hands the table selection over as `profiles`; the API
// reads it as `subscriptionProfiles`.
export const activateSubscriptionProfiles = async ({
    profiles,
    activate,
}: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'subscription-profile-activations',
            data: { subscriptionProfiles: profiles, activate },
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}
